export default __webpack_public_path__ + "static/media/2.55340b6d.jpg";